import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FormSelectItem, FormSelectMultipleComponent, FormSelectMultipleItem} from '@common/form-components';
import * as moment from 'moment';
import {PreciosService} from '@services/precios-service';
import {ProductoService} from '@services/producto-service';
import {MonedaService} from '@services/moneda-service';
import {EntregaService} from '@services/entrega-service';
import {Subscription} from 'rxjs/Subscription';
import {SEARCH_TYPE_COLABORADOR, SearchService} from '@services/search-service';
import {Observable} from 'rxjs/Observable';
import {PrecioGenericViewModel, PrecioViewModel} from '@utils/ViewModels';
import {PrecioMonitor} from '@common/precio-monitor';
import {PricePipe} from '@utils/pipes';
import {DialogsService} from '@services/dialogs-service';
import {dateToUnixTime} from '@utils/DateHelper';
import {SpinnerService} from '@services/spinner-service';
import {ENTREGA_VALUES, NEGOCIO_TYPE_DISPO, NEGOCIO_TYPE_FORWARD, NEGOCIO_TYPE_PAGO_DIFERIDO} from '@services/negocios-service';
import {PATH_PRECIOS} from '../../../navigation/navigation.module';
import {Breakpoints, BreakpointsObserverService} from '@services/breakpoints-observer.service';
import {Subject} from 'rxjs/Subject';
import {ResponsiveService} from '@services/responsive.service';
import {SignalrService} from '../../../signalr/signalR.service';
@Component({
  selector: 'app-precios-agd',
  templateUrl: './precios-agd.component.html',
  styleUrls: ['./precios-agd.component.scss']
})
export class PreciosAgdComponent implements AfterViewInit, OnDestroy {

  meses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'];

  mercadoKey = 'Mercado';
  productoKey = 'Producto';
  monedaKey = 'Moneda';
  posicionKey = 'Posición';
  publicacionKey = 'Hora de Publicación';

  filterMonitorForm: FormGroup;

  filterMonitorOpened = false;

  agruparMonitorOptions: FormSelectItem[] = [
    {Label: this.mercadoKey, Id: this.mercadoKey},
    {Label: this.productoKey, Id: this.productoKey},
  ];

  ordenarMonitorOptions: FormSelectItem[] = [
    {Label: this.publicacionKey, Id: this.publicacionKey},
    {Label: this.posicionKey, Id: this.posicionKey},
    {Label: this.monedaKey, Id: this.monedaKey},
  ];

  viewMonitor = 'mon';
  viewGrid = 'grid';

  view = this.viewMonitor;

  mercadosOptions: FormSelectItem[] = [];
  productoOptions: FormSelectItem[] = [];
  monedaOptions: FormSelectItem[] = [];
  entregaOptions: FormSelectItem[] = [];
  responsablesOptions: FormSelectItem[] = [];
  validadoresOptions: FormSelectItem[] = [];

  @ViewChild('responsableComponent') responsableComp: FormSelectMultipleComponent;
  @ViewChild('validadoresComponent') validadoresComp: FormSelectMultipleComponent;

  subscriptionTsunami: Subscription[] = [];

  monitorFilterInitialState = {
    agrupar: this.agruparMonitorOptions[0],
    agruparDireccion: true,
    ordenar: this.ordenarMonitorOptions[0],
    ordenarDireccion: true,
    fecha: moment().toDate(),
    mercados: [],
    producto: null,
    moneda: null,
    posicion: null,
    entrega: null,
    responsables: [],
    validadores: [],
  }

  // en esta variable vamos a guardar la lista de precios que obtebemos del backend
  // dado que el backend nos agrupa los precios por producto, aqui guardaremos los precios tal cual, sin agupaciones ni yerbas raras
  preciosMonitorRaw: PrecioViewModel[] = [];
  // luego de ordenar los precios, los guardaremos aqui
  monitorGenericoPrecios: PrecioMonitor[] = []

  monitorAltGroupOrder = false; // toggle para ordenar productos alfabeticamente

  filterTipoPrecio = [
    {label: 'DISPONIBLE', selected: true, entregaId: [1, 2]},
    {label: 'FUTURO', selected: false, entregaId: [3]},
    {label: 'PAGO DIFERIDO', selected: false, entregaId: [4]},
  ]

  // grilla
  columns = [
    'fecha', 'negocio', 'entrega', 'moneda', 'soja', 'maiz', 'trigo', 'girasol', 'sorgo', 'mercado', 'responsable', 'validador'
  ];
  filtersGrilla = {};
  pricesGrilla = [];

  sortTimeout; // timeout para el dobleclick o click de ordenamiento

  // Columnas que usan un título no deducible desde su id en this.columns
  needSpecialName = {};
  // Columnas cuyo título en modal de filtro difiere de su título en la tabla
  needSpecialFilterName = {};
  // Columnas que necesitan filtro price
  needPriceFilter = {soja: true, 'maiz': true, trigo: true, sorgo: true, girasol: true};

  // Columnas con tipo de dato desde/hasta en números
  fromToColumns = ['soja', 'maiz', 'trigo', 'girasol', 'sorgo'];
  // Columnas con tipo de dato autocompletar
  arrayColumns = ['responsable', 'validador'];

  chips = [];

  verticalScroll: any;
  scrollSubscriber: any;
  precioPage = 0;
  loadingPrices: boolean;
  allPricesLoaded: boolean;

  // Columna de sorting elegida actualmente
  sortColumn = 'fecha';
  sortOrder = {};

  quickFiltersModels = {
    list: {
      show: true,
      today: true,
      date: new Date()
    },
    grid: {
      today: true,
      date: new Date(),
      producto: null,
      moneda: null,
      entrega: null
    }
  };

  gridFilterForm: FormGroup;

  helpOverlayIsOpen = false;

  destroySubject = new Subject<void>();
  isMobile = false;

  constructor(
    private fb: FormBuilder,
    public preciosService: PreciosService,
    private productosService: ProductoService,
    private monedaService: MonedaService,
    private entregaService: EntregaService,
    private searchService: SearchService,
    private pricePipe: PricePipe,
    private dialogsService: DialogsService,
    private spinnerService: SpinnerService,
    private breakpointsService: BreakpointsObserverService,
    private responsiveService: ResponsiveService,
    private signalRService: SignalrService,
    private cd: ChangeDetectorRef
  ) {
    breakpointsService.observe([Breakpoints.XSmall, Breakpoints.Small])
      .map(x => x.matches)
      .takeUntil(this.destroySubject)
      .subscribe(x => {
        this.isMobile = x;
      });

    this.filterMonitorForm = fb.group({
      agrupar: this.monitorFilterInitialState.agrupar,
      agruparDireccion: this.monitorFilterInitialState.agruparDireccion,
      ordenar: this.monitorFilterInitialState.ordenar,
      ordenarDireccion: this.monitorFilterInitialState.ordenarDireccion,
      fecha: this.monitorFilterInitialState.fecha,
      mercados: [this.monitorFilterInitialState.mercados],
      producto: this.monitorFilterInitialState.producto,
      moneda: this.monitorFilterInitialState.moneda,
      posicion: this.monitorFilterInitialState.posicion,
      entrega: this.monitorFilterInitialState.entrega,
      responsables: [this.monitorFilterInitialState.responsables],
      validadores: [this.monitorFilterInitialState.validadores],
    });

    this.gridFilterForm = this.fb.group({
      fecha: moment().toDate(),
      producto: [[]],
    });

    this.initializeFilterOptions();
    this.onSearchMonitor();
    this.getGrillaPrecios();

    this.columns.forEach(key => {
      this.sortOrder[key] = 0;
    });
  }

  initializeFilterOptions() {
    // inicializamos las options
    this.productosService.loadOptions();
    this.subscriptionTsunami.push(
      this.productosService.Options.subscribe(res => {
        if (res && res.length) {
          this.productoOptions = res.map(y => ({Id: y.ID, Label: y.Producto}))
        }
      })
    );

    this.monedaService.loadOptions();
    this.subscriptionTsunami.push(
      this.monedaService.Options.subscribe(res => {
        if (res && res.length) {
          this.monedaOptions = res.map(y => ({Id: y.ID, Label: `${y.Moneda} ${y.Simbolo}`}));
        }
      })
    );

    this.preciosService.getMercadosPizarra().take(1).subscribe(x => {
      this.mercadosOptions = x.filter(y => y.Visibilidad).map(x => ({Id: x.Id, Label: x.Mercado}));
    });

    this.subscriptionTsunami.push(
      this.entregaService.PosicionOptions.subscribe(res => {
        if (res && res.length) {
          // dado que este es un array dinamico con muchos tipos de datos, lo construimos con los datos internos
          // y guardamos el rawValue para su uso posterior
          this.entregaOptions = res.map((x,i) => ({Id: x.EsPosicion ? x.ID_POS : x.ID, Label: x.EsPosicion ? x.Posicion : x.Entrega, RawValue: JSON.stringify(res[i])}));
        }
      })
    );

    this.subscriptionTsunami.push(
      this.monitorGroupByCtrl.valueChanges.subscribe(x => {
        // por defecto al agrupar por productos el orden se define por el scoring del producto, pero si haces click en el ordenamiento
        // el orden pasa a ser alfabetico. por eso al cambiar las agrupaciones, debemos cambiar el orden al normal
        this.orderMonitor(true);
      })
    );

    this.subscriptionTsunami.push(
      this.monitorOrderCtrl.valueChanges.subscribe(x => {
        this.orderMonitor()
      })
    );

    this.subscriptionTsunami.push(
      this.gridFilterForm.get('fecha').valueChanges.subscribe(x => {
        this.quickFiltersModels.list.today = moment(x).format('DD/MM/YY') === moment().format('DD/MM/YY');
        this.quickFiltersModels.list.date = x;
      })
    );

    this.subscriptionTsunami.push(
      this.gridFilterForm.get('producto').valueChanges.subscribe(x => {
        if (x.length) {
          this.filtersGrilla['filterProductos'] = x.map(y => y.Id);
        } else {
          delete this.filtersGrilla['filterProductos'];
        }
      })
    );

  }

  ngAfterViewInit() {
    // en el afterViewInit nos suscribimos a los cambios de busqueda que suceden en los componentes
    // primero nos suscribimos al searchvalue del componente,
    // usamos debouncetime para dar tiempo al usuario para escribir y usamos switchmap para obtener el ultimo resultado:
    // cuando realizamos una busqueda, si la busqueda cambia a la mitad de la solicitud devolvera el ultimo resultado en lugar del antiguo
    this.subscriptionTsunami.push(
      this.responsableComp.$searchValue.debounceTime(1000).switchMap(res => {
        // aqui realizamos la busqueda
        const searchVal = res.trim();
        if (searchVal.length >= 3) {
          return this.searchService.searchAutocomplete(searchVal, SEARCH_TYPE_COLABORADOR);
        } else {
          // si no hay mas de 3 caracteres, eliminamos la busqueda
          this.responsablesOptions = [];
          return Observable.from([[]]);
        }
      }).subscribe(res => {
        // finalmente nos suscribimos al resultado de la busqueda
        if (res && res.length) {
          this.responsablesOptions = res.map(x => ({Label: x.UserFullName, Id: x.UserId})) ;
        }
      })
    );


    // repetimos los mismo para validadores
    this.subscriptionTsunami.push(
      this.validadoresComp.$searchValue.debounceTime(1000).switchMap(res => {
        // aqui realizamos la busqueda
        const searchVal = res.trim();
        if (searchVal.length >= 3) {
          return this.searchService.searchAutocomplete(searchVal, SEARCH_TYPE_COLABORADOR);
        } else {
          // si no hay mas de 3 caracteres, eliminamos la busqueda
          this.validadoresOptions = [];
          return Observable.from([[]]);
        }
      }).subscribe(res => {
        // finalmente nos suscribimos al resultado de la busqueda
        if (res && res.length) {
          this.validadoresOptions = res.map(x => ({Label: x.UserFullName, Id: x.UserId})) ;
        }
      })
    );

    // CUSTOM VERTICAL SCROLL CON STICKY HEADER
    this.verticalScroll = window.document.querySelector('.mat-drawer-content');

    // INFINITE SCROLL
    this.scrollSubscriber = Observable.fromEvent(this.verticalScroll, 'scroll')
      .debounceTime(300)
      .map(() => this.verticalScroll.scrollTop)
      .takeUntil(this.destroySubject)
      .subscribe(x => {
        const url = location.href.substr(location.href.lastIndexOf('/') + 1);
        if (url !== PATH_PRECIOS || this.view !== this.viewGrid || this.loadingPrices || this.allPricesLoaded) { return; }
        const max = this.verticalScroll.scrollHeight - this.verticalScroll.clientHeight;
        if (x > max * 0.7) {
          this.getGrillaPrecios();
        }
      });

    this.signalRService.newPrice.takeUntil(this.destroySubject).subscribe(() => {
      this.onSearchMonitor();
      this.resetGrillaPrecios();
      this.getGrillaPrecios();
      this.cd.detectChanges();
    });
  }

  ngOnDestroy() {
    this.subscriptionTsunami.forEach(x => x.unsubscribe());
    this.destroySubject.next();
  }

  selectView(view: string) {
    this.view = view;
  }

  // region monitor

  toggleMonitorFilterVisibility(e: MouseEvent) {
    if (e.srcElement.id === 'monitorFilterClick' || e.srcElement.id === 'grillaFilterClick') {
      this.filterMonitorOpened = !this.filterMonitorOpened;
    }
  }

  onSearchMonitor() {
    if (this.filterMonitorForm.invalid) {
      return;
    }

    const filterValue = this.filterMonitorForm.getRawValue() as FilterMonitorRawValue;

    let entrega: number = null;
    let posicion: number = null;
    this.preciosMonitorRaw = [];
    
    if (filterValue.entrega) {
      const entregaSelected = JSON.parse(filterValue.entrega.RawValue);

      if (entregaSelected.EsPosicion) {
        posicion = entregaSelected.ID_POS;
      } else {
        entrega = entregaSelected.ID;
      }
    }

    this.preciosMonitorRaw = [];
    this.preciosService.getMonitorPrecios(
      moment(filterValue.fecha).toDate(),
      this.getValueOrNull(filterValue.producto),
      this.getValueOrNull(filterValue.moneda),
      posicion,
      entrega,
      filterValue.responsables.map(x => Number(x.Id)),
      filterValue.validadores.map(x => Number(x.Id)),
      moment(filterValue.fecha).format('DD/MM/YY') === moment().format('DD/MM/YY'),
      filterValue.mercados.map(x => Number(x.Id))
    ).subscribe(res => {
      const productsResponse = res.ResponseData;
      if (productsResponse && productsResponse.length > 0) {
        this.preciosMonitorRaw = [];
        res.ResponseData.forEach(group => {
          group.Precios.forEach(precio => {
            this.preciosMonitorRaw.push({...precio, Producto: group.Producto} as PrecioViewModel);
          });
        })
        this.orderMonitor();

      } else {
        this.preciosMonitorRaw = [];
        this.orderMonitor();
      }
    });
    this.filterMonitorOpened = false;
  }

  deleteMonitorFilters() {
    this.filterMonitorForm.reset(this.monitorFilterInitialState);
    this.onSearchMonitor();
  }

  getValueOrNull(val: FormSelectItem) {
    return val === null ? null : Number(val.Id);
  }

  orderMonitor(resetAlt = false): void {
    if (resetAlt) {
      this.monitorAltGroupOrder = false;
    }

    if (this.preciosMonitorRaw.length) {



      let precios = this.preciosMonitorRaw.map(x => {
        return {
          Fecha: moment(x.Fecha).format('HH:mm') + ' hs.',
          Grupo: this.monitorGroupBy === this.mercadoKey ? x.Mercado.Mercado : x.Producto.Producto,
          Superior: this.monitorGroupBy === this.mercadoKey ? x.Producto.Producto : x.Mercado.Mercado,
          Inferior: x.Posicion !== null ? x.Posicion.Posicion : x.Entrega.Entrega,
          Moneda: x.Moneda.Simbolo,
          Precio: this.pricePipe.transform(x.Precio, 'fill'),
          Varianza: x.Varianza,
          PrecioRAW: this.parsePrecioGenericPrecio(x),
          SaltoLinea: false,
          FechaRaw: moment(x.Fecha).unix(),
        } as PrecioMonitor;
      });

      // previo a realizar el ordenamiento, vamos a filtrar los resultados segun si se muestran segun el filtro botonera

      precios = precios.filter(precio => {
        // recorremos el array de filtros
        for (let i = 0; i < this.filterTipoPrecio.length; i++) {
          // cache del filtro a verificar
          const filter = this.filterTipoPrecio[i];
          // si el filtro esta activo y el precio forma parte del filtro activo segun el id de su entrega, entra
          if (filter.selected && filter.entregaId.some(x => x === precio.PrecioRAW.Entrega.Id)) {
            return true;
          }
        }
        return false;
      });

      precios.sort((a, b) => {
        /* damos inicio a la parafernalia que sera esta sortFunction...
        no existe una division en secciones si no que los grupos y precios-seccion se dibujan segun la posicion
        en la que se encuentran dentro del array... por lo que el sort completo se define aqui y ahora...*/

        // NOTA AL POBRE QUE TENGA QUE MODIFICAR ESTO
        // el ordenamiento aqui y en pizarra difieren, aqui los saltos de linea hacen que sea imposible ordenar por
        // el subgrupo, por lo que quitamos producto y mercado de la lista de ordenamientos. Pero pizarra al no tener salto
        // de linea, no necesita esto, por lo que aun se puede ordenar por esos valores

        // Paso 1: Ordenar los Grupos
        if (a.Grupo !== b.Grupo) {
          if (this.monitorGroupBy === this.productoKey) {
            return this.monitorAltGroupOrder ?
              // alternativo, alfabeticamente
              comparar(a.Grupo, b.Grupo, this.monitorGroupDirection) :
              // normal, por score de producto
              comparar(getProductoScoreVal(a.Grupo), getProductoScoreVal(b.Grupo), this.monitorGroupDirection)
          } else {
            return comparar(a.Grupo, b.Grupo, this.monitorGroupDirection)
          }
        }

        // Paso 2: Ordenar en cada grupo el subgrupo, ya sea producto o mercado.
        // Por cada producto o mercado se debe producir un salto de linea. Dicho salto se define más abajo.

        // tenemos en cuenta el grupo, si es producto, ordenamos por mercado internamente y viceversa para producto
        // esto es asi dado que ahora producto y mercado, internamente son un subgrupo, por lo que se quitan de la lista de
        // opciones de ordenamiento

        if (a.Superior !== b.Superior) {
          if (this.monitorGroupBy === this.productoKey) {
            // comparamos segun el orden superior
            return comparar(a.Superior, b.Superior, true);
          }

          if (this.monitorGroupBy === this.mercadoKey) {
            // comparamos segun el score del producto
            return comparar(getProductoScoreVal(a.Superior), getProductoScoreVal(b.Superior), true);
          }
        }

        // Paso 3: Orden interno de los subgrupos (mercado o producto)
        console.log(this.monitorOrder);
        switch (this.monitorOrder) {
          case this.monedaKey:
            // comparamos segun la moneda y si son iguales, por fecha
            return a.Moneda === b.Moneda ? comparar(a.FechaRaw, b.FechaRaw, this.monitorOrderDirection)
              : comparar(a.Moneda, b.Moneda, this.monitorOrderDirection);
          case this.publicacionKey:
            return comparar(a.FechaRaw, b.FechaRaw, this.monitorOrderDirection);
          case this.posicionKey:
            const aVal = a.Inferior.toUpperCase();
            const bVal = b.Inferior.toUpperCase();
            // primero verificamos si estamos ante entidades iguales
            if (getScore(aVal) === getScore(bVal)) {
              // estamos ante entidades iguales, realizamos las comparaciones internas
              // FORWARD
              if (getScore(aVal) === 10) {
                // si son iguales, ordenar por fecha de publicacion
                // negamos el orden dado que ENTREGADO tiene prioridad, pero es LGBT y larga con E, pero la A viene antes...
                return aVal === bVal ? comparar(a.FechaRaw, b.FechaRaw, this.monitorOrderDirection) :
                  comparar(aVal, bVal, !this.monitorOrderDirection);
                // POSICION
              } else if (getScore(aVal) === 5) {
                const namesA = aVal.split('-');
                const namesB = bVal.split('-');

                if (namesA.length + namesB.length === 2) {
                  return this.monitorOrderDirection ? this.meses.indexOf(namesA[0]) - this.meses.indexOf(namesB[0]) : this.meses.indexOf(namesB[0]) - this.meses.indexOf(namesA[0]);
                } else if (namesA.length !== namesB.length) {
                  return this.monitorOrderDirection ? namesA.length - namesB.length : namesB.length - namesA.length;
                } else {
                  if (namesA[1] === namesB[1]) {
                    return this.monitorOrderDirection ? this.meses.indexOf(namesA[0]) - this.meses.indexOf(namesB[0]) : this.meses.indexOf(namesB[0]) - this.meses.indexOf(namesA[0]);
                  } else {
                    return this.monitorOrderDirection ? Number(namesA[1]) - Number(namesB[1]) : Number(namesB[1]) - Number(namesA[1]);
                  }
                }
                // DIFERIDO
              } else if (getScore(aVal) === 3) {
                return aVal === bVal ? comparar(a.FechaRaw, b.FechaRaw, this.monitorOrderDirection) :
                  comparar(moment(aVal, 'DD/MM/YYYY').unix(), moment(bVal, 'DD/MM/YYYY').unix(), this.monitorOrderDirection);
              }
            } else {
              // en caso de ser entidades distintas, las ordenamos segun puntaje de orden
              return comparar(getScore(aVal), getScore(bVal), !this.monitorOrderDirection);
            }
        }
        return 0;
      })

      // ahora aplicamos el salto de linea
      precios.forEach((precio, i) => {
        // recordemos que los arrays se arrancan en 0 por lo que para sumar 1, debemos sumar 2 al compara el length
        if ((i + 2) <= precios.length) {
          // si el siguiente valor superior, es distinto al valor actual, en el actual preparamos el salto de linea
          if (precio.Superior !== precios[i+1].Superior) {
            precio.SaltoLinea = true;
          }
        }
      })

      this.monitorGenericoPrecios = [];
      this.monitorGenericoPrecios = precios.slice();
    } else {
      this.monitorGenericoPrecios = [];
    }
  }

  parsePrecioGenericPrecio(precio: PrecioViewModel): PrecioGenericViewModel {
    return {
      Actual: precio.Actual,
      Entrega: precio.Entrega,
      FechaCreacion: moment(precio.Fecha).unix(),
      FechaPublicacion: 0,
      Id: precio.Id,
      Mercado: precio.Mercado,
      Moneda: precio.Moneda,
      Posicion: precio.Posicion,
      Precio: precio.Precio,
      Producto: precio.Producto,
      Usuario: precio.Usuario,
      Validador: precio.Validador,
      Varianza: precio.Varianza
    }
  }

  monitorGroupOrderChange(): void {
    // revisamos si el grupo es productos, de ser asi, pasamos al modo alternativo
    // donde ordenamos los productos alfabeticamente y no por score

    // si estamos ordenando el grupo y estamos en productos siempre estaremos en el modo alternativo,
    // de lo contrario lo desactivamos
    this.monitorAltGroupOrder = this.monitorGroupBy === this.productoKey;

    this.monitorGroupDirectionCtrl.setValue(!this.monitorGroupDirection);
    this.orderMonitor();
  }

  changePrecioTypeFilter(index: number) {
    // evitamos que se apaguen todos los filtros a la vez
    if (
      this.filterTipoPrecio[index].selected &&
      this.filterTipoPrecio.filter(x => x.selected).length <= 1
    ) {
      return;
    }
    this.filterTipoPrecio[index].selected = !this.filterTipoPrecio[index].selected;
    this.orderMonitor();
  }

  get monitorGroupBy(): string {
    return this.filterMonitorForm.get('agrupar').value.Id.toString();
  }

  get monitorGroupDirection(): boolean {
    return this.filterMonitorForm.get('agruparDireccion').value;
  }

  get monitorOrder(): string {
    return this.filterMonitorForm.get('ordenar').value.Id.toString();
  }

  get monitorOrderDirection(): boolean {
    return this.filterMonitorForm.get('ordenarDireccion').value;
  }

  get monitorGroupByCtrl(): AbstractControl {
    return this.filterMonitorForm.get('agrupar');
  }

  get monitorOrderCtrl(): AbstractControl {
    return this.filterMonitorForm.get('ordenar');
  }

  get monitorGroupDirectionCtrl(): AbstractControl {
    return this.filterMonitorForm.get('agruparDireccion');
  }

  get monitorOrderDirectionCtrl(): AbstractControl {
    return this.filterMonitorForm.get('ordenarDireccion');
  }

  // endregion

  // a partir de aca empieza la parte fea de grilla, perdon pero ni ganas de actualizar este codigo, el codigo anda, no te quejes
  // si estas actualizando a angular 13 por favor hacelo de cero, sin grilla dinamica, no vale la pena rescatar nada

  openFilterModal(column) {
    clearTimeout(this.sortTimeout);
    this.dialogsService.showPreciosFilterDialog(column, this.getColumnTitleForFilter(column), this.filtersGrilla)
      .subscribe((res: any) => {
        if (res) {
          this.filtersGrilla = res.filters;

          // Si elegimos Guardar pero no cargamos ninguna info en este filtro, lo quitamos
          if (this.fromToColumns.indexOf(column) >= 0) {
            if (typeof this.filtersGrilla[column].model1 !== 'number' && typeof this.filtersGrilla[column].model2 !== 'number') {
              delete this.filtersGrilla[column];
            }
          } else if (this.arrayColumns.indexOf(column) >= 0) {
            if (!this.filtersGrilla[column] || this.filtersGrilla[column].length === 0) {
              delete this.filtersGrilla[column];
            }
          }
        }

        if (this.filtersGrilla['fecha']) {
          this.quickFiltersModels.list.today = false;
        }

        this.buildChips();

        this.resetGrillaPrecios();
        this.getGrillaPrecios();
      });
  }

  getColumnTitleForFilter(col) {
    return this.needSpecialFilterName[col] || this.getColumnTitle(col);
  }

  buildChips() {
    this.chips = Object.keys(this.filtersGrilla).map(key => {
      let value = '';
      switch (key) {
        case 'fecha':
        case 'cotización':
          value = moment(this.filtersGrilla[key].startDate).format('DD-MM-YY') + ' al ' + moment(this.filtersGrilla[key].endDate).format('DD-MM-YY');
          break;
        case 'negocio':
        case 'entrega':
        case 'moneda':
        case 'mercado':
          value = this.filtersGrilla[key].model1Value;
          break;
        case 'responsable':
          if (this.filtersGrilla['responsable'].length === 1) {
            value = this.filtersGrilla['responsable'][0].UserFullName;
          } else {
            value = 'Varios';
          }
          break;
        case 'validador':
          if (this.filtersGrilla['validador'].length === 1) {
            value = this.filtersGrilla['validador'][0].UserFullName;
          } else {
            value = 'Varios';
          }
          break;
        case 'soja':
        case 'maiz':
        case 'trigo':
        case 'sorgo':
        case 'girasol':
          value = this.filtersGrilla[key].model1 + '-' + this.filtersGrilla[key].model2;
          break;
        case 'filterProductos':
          if (this.filtersGrilla['filterProductos'].length === 1) {
            value = this.productoOptions[this.productoOptions.findIndex(x => x.Id === this.filtersGrilla['filterProductos'][0])].Label;
          } else {
            value = 'Varios';
          }

      }

      return {
        col: key,
        title: this.getChipsTitle(key),
        value
      };
    });
  }

  getChipsTitle(key) {
    if (key === 'filterProductos') {
      return 'Producto';
    } else {
      return key.charAt(0).toUpperCase() + key.slice(1);
    }
  }

  resetGrillaPrecios() {
    this.precioPage = 0;
    this.allPricesLoaded = false;
    this.pricesGrilla = [];
  }

  getColumnOrder(): any {
    const isProduct = this.productoOptions.find(x => x.Label.toLowerCase() === this.sortColumn);
    if (isProduct) {
      return {
        ColumnName: 'producto',
        ProductoId: isProduct.Id
      };
    }
    return {
      ColumnName: this.sortColumn,
      ProductoId: 0
    };
  }

  getGrillaPrecios(): void {
    if (this.allPricesLoaded) { return; }
    this.spinnerService.setShowFlag(true);
    const quickFilters = this.quickFiltersModels.list;
    const gridFilters: any = this.filtersGrilla;
    let negocioFilter = '';
    let idPosicion = 0;
    let idEntrega = 0;
    let idMoneda = 0;
    let idUsuarios: Array<number>;
    let idValidadores: Array<number>;
    const idMercado = this.filtersGrilla['mercado'] ? this.filtersGrilla['mercado'].model1 : 0;
    const productFilter: any = [];
    let productosFilterIds = [];
    if (gridFilters.negocio) {
      const negocio = gridFilters.negocio.model1;
      switch (negocio) {
        case 'FORWARD':
          negocioFilter = 'F';
          break;
        case 'DISPONIBLE':
          negocioFilter = 'D';
          break;
        case 'PAGO_DIFERIDO':
          negocioFilter = 'P';
          break;
        default:
          negocioFilter = 'B';
          break;
      }
    }
    if (gridFilters.entrega) {
      const posicionFilter = gridFilters.entrega.model1;
      idPosicion = posicionFilter.EsPosicion ? posicionFilter.ID_POS : 0;
      idEntrega = posicionFilter.EsPosicion ? 0 : posicionFilter.ID;
    }
    if (gridFilters.moneda) {
      idMoneda = gridFilters.moneda.model1;
    }
    if (gridFilters.responsable) {
      idUsuarios = gridFilters.responsable.map(x => {
        return x.UserId;
      });
    }
    if (gridFilters.validador) {
      idValidadores = gridFilters.validador.map(x => {
        return x.UserId;
      });
    }
    if (gridFilters.filterProductos) {
      productosFilterIds = gridFilters.filterProductos;
    }

    this.productoOptions.forEach(po => {
      if (gridFilters[po.Label.toLowerCase()]) {
        const prodFilter = gridFilters[po.Label.toLowerCase()];
        productFilter.push({
          ProductId: po.Id,
          DecimalRange: {
            MinValue: prodFilter.model1,
            MaxValue: prodFilter.model2
          }
        });
      }
    });

    // fecha de publicacion
    let fromDate = new Date();
    let toDate = new Date();

    let cotizacionFromDate = 0;
    let cotizacionToDate = 0;

    if (quickFilters.today) {
      fromDate = moment(fromDate).startOf('day').toDate();
      toDate = moment(toDate).endOf('day').toDate();
    } else {
      if (gridFilters.fecha) {
        fromDate = moment(gridFilters.fecha.startDate).startOf('day').toDate();
        toDate = moment(gridFilters.fecha.endDate).endOf('day').toDate();

      } else {
        fromDate = moment(quickFilters.date).startOf('day').toDate();
        toDate = moment(quickFilters.date).endOf('day').toDate();
      }

      if (gridFilters.cotizacion) {
        cotizacionFromDate = dateToUnixTime(moment(gridFilters.cotización.startDate).startOf('day').toDate());
        cotizacionToDate = dateToUnixTime(moment(gridFilters.cotización.endDate).endOf('day').toDate());
      }
    }
    const fromTime: number = dateToUnixTime(fromDate);
    const toTime: number = dateToUnixTime(toDate);

    this.loadingPrices = true;
    const columnOrder = this.getColumnOrder();

    this.preciosService.getGrillaPrecios(this.precioPage, columnOrder.ColumnName, this.sortOrder[this.sortColumn], columnOrder.ProductoId,
      fromTime, toTime, negocioFilter, idPosicion, idMoneda, idEntrega, idUsuarios, productFilter, idValidadores, productosFilterIds, idMercado)
      .subscribe((response: any) => {
        if (response.ResponseData) {
          const data = response.ResponseData.Item;
          data.forEach(r => {
            const price = {
              entrega: this.getEntregaText(r),
              negocio: this.getNegocioText(r),
              moneda: r.Moneda.Simbolo,
              fecha: moment(new Date(r.Fecha)).format('DD/MM/YYYY hh:mm'),
              responsable: r.Responsable.UserFullName,
              validador: r.PrecioProducto[0] && r.PrecioProducto[0].Validador ? r.PrecioProducto[0].Validador.UserFullName : '-',
              mercado: r.Mercado ? r.Mercado.Mercado : '-'
            };
            r.PrecioProducto.map(p => {
              const propertyName = p.Producto.Producto.toString().toLowerCase();
              price[propertyName] = p.Precio.Precio;
            });
            this.pricesGrilla.push(price);
          });
          this.allPricesLoaded = parseInt(response.ResponseData.Total, 10) === this.pricesGrilla.length;
          this.precioPage++;
        }
        this.loadingPrices = false;
        this.spinnerService.setShowFlag(false);
      }, err => this.spinnerService.setShowFlag(false));
  }

  getColumnTitle(col) {
    return col.charAt(0).toUpperCase() + col.slice(1);
  }

  getEntregaText(precio) {

    if (precio.Entrega.Entrega === ENTREGA_VALUES.N_POSICIONES || precio.Entrega.Entrega === ENTREGA_VALUES.PAGO_DIFERIDO_PESOS) {
      return precio.Posicion.Posicion;
    } else {
      return precio.Entrega.Entrega;
    }
  }

  getNegocioText(precio) {

    if (precio.PosicionChicago) {
      return 'Basis';
    } else if (precio.Entrega.Entrega === ENTREGA_VALUES.N_POSICIONES) {
      return NEGOCIO_TYPE_FORWARD;
    } else if (precio.Entrega.Entrega === ENTREGA_VALUES.PAGO_DIFERIDO_PESOS) {
      return NEGOCIO_TYPE_PAGO_DIFERIDO;
    } else {
      return NEGOCIO_TYPE_DISPO;
    }
  }

  sortByColumn(column, immediate) {
    clearTimeout(this.sortTimeout);
    this.sortTimeout = setTimeout(() => {
      if (this.sortColumn === column) {
        this.sortOrder[column] = (this.sortOrder[column] + 1) % 2;
      } else {
        this.columns.forEach(element => {
          this.sortOrder[element] = 0;
        });
        this.sortOrder[column] = (this.sortOrder[column] || 0);
      }
      this.sortColumn = column;
      this.resetGrillaPrecios();
      this.getGrillaPrecios();
    }, immediate ? 0 : 250);
  }

  removeFilter(chip) {
    this.chips = this.chips.filter(c => c.col !== chip.col);

    if (chip.col === 'fecha') {
      this.gridFilterForm.get('fecha').setValue(moment().toDate())
    }

    if (chip.col === 'filterProductos') {
      this.gridFilterForm.get('producto').setValue([]);
    }

    delete this.filtersGrilla[chip.col];

    this.resetGrillaPrecios();
    this.getGrillaPrecios();
  }

  applyGrillaFilters() {
    this.resetGrillaPrecios();
    this.buildChips();
    this.getGrillaPrecios();
    this.filterMonitorOpened = false;
  }

  resetGrillaFilters() {
    this.quickFiltersModels.grid = {
      today: true,
      date: new Date(),
      producto: null,
      moneda: null,
      entrega: null
    };
    this.gridFilterForm.reset({
      fecha: moment().toDate(),
      producto: [],
    }, {emitEvent: false})
    this.filtersGrilla = {};
    this.chips = [];
    this.sortColumn = 'fecha';
    this.filterMonitorOpened = false;
    this.applyGrillaFilters();
  }

  public printPrecios() {
    const filtroFecha = this.filterMonitorForm.get('fecha');
    const fecha = filtroFecha ? moment(filtroFecha.value).toDate() : moment().toDate();
    this.dialogsService.imprimirPreciosPNG('Mercado AGD', fecha, this.monitorGenericoPrecios);
  }


}

interface FilterMonitorRawValue {
  agrupar: FormSelectItem,
  agruparDireccion: boolean,
  ordenar: FormSelectItem,
  ordenarDireccion: boolean,
  fecha: any,
  mercados: FormSelectMultipleItem[] | null,
  producto: FormSelectItem | null,
  moneda: FormSelectItem | null,
  entrega: FormSelectItem | null,
  posicion: FormSelectItem | null,
  responsables: FormSelectMultipleItem[],
  validadores: FormSelectMultipleItem[],
}

export function comparar(a, b, direcion: boolean): number {
  if (a < b) { return direcion ? -1 : 1; }
  if (a > b) { return direcion ? 1 : -1; }
  return 0;
}

function getScore(val: string): number {
  let score = 0;
  if (val === 'ENTREGADO' || val === 'A ENTREGAR') {score = 10;}
  if (val.includes('-')) {score = 5;}
  if (val.includes('/')) {score = 3;}
  return score;
}

export function getProductoScoreVal(val: string): number {
  const producto = val.toLowerCase();
  const values = ['sorgo', 'girasol', 'trigo', 'maiz', 'maíz', 'soja'];
  // en caso de ser un producto nuevo, el resultado será -1 por lo que estara debajo de todos en la lista
  return values.indexOf(val);
}




// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/precios-agd/precios-agd.component.ts